import type { useNotify } from 'react-admin'

import { dominantFailureCode, exportErrorMessageKey } from './exportErrors'
import type { TExportError, TExportFailure } from './exportErrors'

export type TNotify = ReturnType<typeof useNotify>

export type TTranslate = (
  key: string,
  options?: Record<string, unknown>,
) => string

export const RUNNING_NOTICE_DELAY = 700

const RUNNING_AUTO_HIDE_DURATION = 2000
const TERMINAL_AUTO_HIDE_DURATION = 5000

export const notifyRunning = (notify: TNotify, t: TTranslate): void => {
  notify(t('alarm_report.export.notify.running'), {
    type: 'info',
    autoHideDuration: RUNNING_AUTO_HIDE_DURATION,
  })
}

export const notifyOutcome = (
  notify: TNotify,
  t: TTranslate,
  failures: TExportFailure[],
): void => {
  const count = failures.length

  if (count === 0) {
    notify(t('alarm_report.export.notify.succeeded'), {
      type: 'success',
      autoHideDuration: TERMINAL_AUTO_HIDE_DURATION,
    })
    return
  }

  notify(
    t('alarm_report.export.notify.partial', {
      count,
      reason: t(
        exportErrorMessageKey(dominantFailureCode(failures) ?? 'UNKNOWN'),
      ),
    }),
    { type: 'warning', autoHideDuration: TERMINAL_AUTO_HIDE_DURATION },
  )
}

export const notifyFailure = (
  notify: TNotify,
  t: TTranslate,
  error: TExportError,
): void => {
  notify(
    t('alarm_report.export.notify.failed', {
      reason: t(exportErrorMessageKey(error.code)),
    }),
    { type: 'error', autoHideDuration: TERMINAL_AUTO_HIDE_DURATION },
  )
}
